import moment from "moment";
import {formatTimeByTheme, getThemeName} from "./themeUtils";


//converting dates from DD/MM/YYYY to DD-MM-YYYY to use in routes/urls and back
export function dateStringToUrlString(dateString) {
    return dateString ? dateString.replaceAll("/", "-") : dateString;
}

export function dateStringFromUrlParam(param) {
    return param ? param.replaceAll("-", "/") : param;
}

export function formatPortDate(dateTimeString) {
    let portDate = moment(dateTimeString, 'DD/MM/YYYY');
    return portDate.format("dddd Do MMMM YYYY");
}

export function formatCartElementDate(dateTimeString) {
    let date = moment(dateTimeString, 'DD/MM/YYYY');
    return date.format("ddd Do MMMM YYYY");
}

export function formatTimeHM(dateTimeString, defaultVal) {
    if(!dateTimeString) {
        return defaultVal;
    }

    let dateTime = moment(dateTimeString, 'DD/MM/YYYY HH:mm');
    let time = dateTime.format("HH:mm");
    return formatTimeByTheme(time);
}

export function prepareDateTimeForOverlapCheck(dateTimeString, add) {
    const dateTime = moment(dateTimeString, 'DD/MM/YYYY HH:mm');

    if(add) {
        dateTime.add(29, 'minutes');
    }
    else {
        dateTime.subtract(29, 'minutes');
    }

    return dateTime.format("YYYY-MM-DDTHH:mm");
}

export function formatPortTimeTandC(dateTimeString) {
    let portDate = moment(dateTimeString, 'DD/MM/YYYY');
    return portDate.format("YYYY-MM-DD");
}

export function formatDuration(durationInMinutes) {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;
    return `${hours}h${minutes || ""}`;
}

export function isCruiseStartDateDenied(cruiseStart, isAgency) {
    if (!cruiseStart) {
        return false;
    }

    const cruiseStartMoment = moment(cruiseStart, "DD/MM/YYYY");

    // agency is never denied
    if(isAgency) {
        return false;
    }

    // customers are denied if cruise start is already in the past
    return cruiseStartMoment.isBefore(moment().subtract(1, 'days'));
}

export function formatItineraryDepartDate(cruiseDeparture) {
    const themeName = getThemeName();
    switch (themeName) {
        case "acl":
        case "cfc":
            return moment(cruiseDeparture, "DD/MM/YYYY").format("DD MMMM YYYY");
        default:
            return moment(cruiseDeparture, "DD/MM/YYYY").format("DD MMMM");
    }
}

export function convertDMYtoYMD(dateString) {
    return moment(dateString, 'DD/MM/YYYY').format("YYYY-MM-DD");
}

export function convertYMDtoDMY(dateString) {
    return moment(dateString, "YYYY-MM-DD").format("DD/MM/YYYY");
}

export function formatCruiseStartDate(startDate) {
    return moment(startDate,"DD/MM/YYYY").format("DD MMMM YYYY");
}

export function isValidDate(dateString, minDate, maxDate) {
    const regex = /^([1-9]|0[1-9]|[12][0-9]|3[01])\/([1-9]|0[1-9]|1[012])\/(19|20)\d\d$/;
    if(!regex.test(dateString)) {
        return false;
    }

    const date = moment(dateString, "DD/MM/YYYY");

    if(!date.isValid()) {
        return false;
    }

    //check for min and max if set
    if(minDate) {
        const min = moment(minDate, "DD/MM/YYYY");
        if(date.isBefore(min)) {
            return false;
        }
    }
    if(maxDate) {
        const max = moment(maxDate, "DD/MM/YYYY");
        if(date.isAfter(max)) {
            return false;
        }
    }

    return true;
}

export function potentialdmYtoDMY(dateString) {
    return moment(dateString, "DD/MM/YYYY").format("DD/MM/YYYY");
}

export function isDateInThePast(dateString) {
    const date = moment(dateString, "DD/MM/YYYY");

    return date.isBefore(moment());
}

export function isDateInTheFuture(dateString) {
    const date = moment(dateString, "DD/MM/YYYY");

    return date.isAfter(moment());
}

export function dateSubMonths(date, nrMonths) {
    const dateCopy = new Date(date);
    dateCopy.setMonth(dateCopy.getMonth() - nrMonths);

    return dateCopy;
}

export function dateAddMonths(date, nrMonths) {
    const dateCopy = new Date(date);
    dateCopy.setMonth(dateCopy.getMonth() + nrMonths);

    return dateCopy;
}

export function dateObjectToDMY(dateObject) {
    return dateObject?.toLocaleDateString("en-GB");
}

export function convertDMYToDateObject(dmyString) {
    const [d, m, y] = dmyString.split(/\D/);

    return new Date(y, m-1, d);
}

const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

export const enGBFnsLocale = {
    localize: {
        day: n => days[n],
        month: n => months[n]
    },
    formatLong: {
        date: () => 'mm/dd/yyyy'
    },   options: {
        weekStartsOn: 1 /* Monday */,
        firstWeekContainsDate: 4,
    },
}

